'use client';

import { useTranslations } from 'next-intl';
import { lazy, Suspense, useCallback, useState } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Button } from '@//components/Button';

const VehicleDetailsModal = lazy(() => import('@//containers/VehicleDetailsModal'));

interface ShowAllVehicleDetailsProps {
  vehicle: ElasticVehicle;
}

const ShowAllVehicleDetails = ({ vehicle }: ShowAllVehicleDetailsProps) => {
  const t = useTranslations('pages.item.vehicleDetailsSection');
  const [open, setOpen] = useState(false);
  const onOpen = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);

  return (
    <>
      <Suspense fallback={null}>
        <VehicleDetailsModal isOpen={open} vehicle={vehicle} onCloseModal={onClose} showLinks />
      </Suspense>
      <Button
        title={t('showAllButton.title')}
        size="lg"
        variant="secondary"
        fullWidthLtMd
        onClick={onOpen}
        data-testid="show-all-vehicle-details-button"
      >
        {t('showAllButton.label')}
      </Button>
    </>
  );
};
export default ShowAllVehicleDetails;
